import * as arrayUtils from './array/index'
import * as browserUtils from './browser/index'
import * as colorUtils from './color/index'
import * as dateUtils from './date/index'
import * as functionUtils from './function/index'
import * as greekUtils from './greek/index'
import * as helperUtils from './helper/index'
import * as mathUtils from './math/index'
import * as objectUtils from './object/index'
import * as stringUtils from './string/index'
import * as typeUtils from './type/index'

export * as arrayUtils from './array/index'
export * as browserUtils from './browser/index'
export * as colorUtils from './color/index'
export * as dateUtils from './date/index'
export * as functionUtils from './function/index'
export * as greekUtils from './greek/index'
export * as helperUtils from './helper/index'
export * as mathUtils from './math/index'
export * as objectUtils from './object/index'
export * as stringUtils from './string/index'
export * as typeUtils from './type/index'

const utils = {
  array   : arrayUtils,
  browser : browserUtils,
  color   : colorUtils,
  date    : dateUtils,
  function: functionUtils,
  greek   : greekUtils,
  helper  : helperUtils,
  math    : mathUtils,
  object  : objectUtils,
  string  : stringUtils,
  type    : typeUtils
}

export default utils
